export enum ALERT_SOURCE {
    DAILY_WARNING = 'DAILY_WARNING', // ข่าวเตือนภัยรายวัน
    SYSTEM_GENERATED = 'SYSTEM_GENERATED', // สร้างจากระบบ
}

export const ALERT_SOURCE_DATA: { label: string, value: string }[] = [
    {
        label: "ข่าวเตือนภัยรายวัน",
        value: ALERT_SOURCE.DAILY_WARNING
    },
    {
        label: "สร้างจากระบบ",
        value: ALERT_SOURCE.SYSTEM_GENERATED
    },
]

export enum BANNER_GROUP {
    HOME = 'หน้าหลัก', // หน้าหลัก
    ADMISSION = 'Admission', // Admission
    NEWS = 'ข่าวประชาสัมพันธ์', // ข่าวประชาสัมพันธ์
    ACTIVITY = 'ปฏิทินกิจกรรม', // ปฏิทินกิจกรรม
}

export const banner_group_data: { label: string, value: string }[] = Object.entries(BANNER_GROUP).map(([key, value]) => {
    return {
        label: value,
        value: key
    }
})